import React, { useEffect, useState } from "react"; // Đã thêm React vào đây
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Notification() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [isShow, setShow] = useState(false);
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [notifyItem, setNotifyItem] = useState();
    
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify !== res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
    }, []);

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .notification-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. THÔNG TIN USER (ĐỒNG BỘ CÁC TRANG)              */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. DANH SÁCH BANNER (GIỐNG ẢNH BẠN GỬI)            */
                /* ================================================== */
                .notification-content {
                    padding: 0 15px 20px 15px;
                }
                .box-image {
                    background: #fff;
                    border-radius: 8px;
                    margin-bottom: 15px;
                    box-shadow: 0 3px 6px rgba(0,0,0,0.1);
                    overflow: hidden;
                    cursor: pointer;
                    transition: transform 0.2s;
                }
                .box-image:active {
                    transform: scale(0.98);
                }
                .box-image img {
                    width: 100%;
                    height: auto;
                    display: block;
                }
                .box-image-title {
                    padding: 12px 15px;
                    font-size: 15px;
                    font-weight: bold;
                    color: #333;
                    text-align: center;
                    background: #fff;
                }
                
                .empty-notify {
                    text-align: center;
                    color: #888;
                    margin-top: 50px;
                    font-size: 15px;
                }

                /* ================================================== */
                /* 4. MODAL CHI TIẾT THÔNG BÁO                        */
                /* ================================================== */
                .custom-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6);
                    z-index: 9999999;
                    display: flex; align-items: center; justify-content: center;
                    padding: 15px;
                }
                .custom-modal-content {
                    background: #fff;
                    width: 100%;
                    max-width: 500px;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.3);
                    animation: slideUp 0.3s ease-out;
                    display: flex;
                    flex-direction: column;
                    max-height: 85vh; /* Để cuộn được nếu quá dài */
                }
                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                .custom-modal-header {
                    background: #b71c1c;
                    color: #fff;
                    padding: 15px;
                    font-size: 16px;
                    font-weight: bold;
                    text-align: center;
                    text-transform: uppercase;
                }
                .custom-modal-body {
                    padding: 15px;
                    overflow-y: auto;
                    color: #333;
                    line-height: 1.6;
                    font-size: 14px;
                }
                .custom-modal-body img {
                    max-width: 100%;
                    height: auto;
                    border-radius: 6px;
                    display: block;
                    margin: 0 auto;
                }
                .custom-modal-footer {
                    padding: 15px;
                    background: #f9f9f9;
                    border-top: 1px solid #eee;
                }
                .btn-close-modal {
                    background: #555;
                    color: #fff;
                    border: none;
                    padding: 12px;
                    border-radius: 6px;
                    font-weight: bold;
                    cursor: pointer;
                    width: 100%;
                    font-size: 15px;
                    text-transform: uppercase;
                }
            `}</style>

            <div className="notification-wrapper">
                
              

                {/* 2. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                    
                    <h1 className="page-title-h1">Thông báo</h1>
                </div>

                {/* 3. NỘI DUNG (CÁC BANNER GIỐNG ẢNH) */}
                <div className="notification-content">
                    {notify != null && notify.length > 0 ? (
                        <AnimatedPage>
                            {notify.map((item, index) => (
                                <React.Fragment key={index}>
                                    {index > 1 && item.title !== "marquee" && item.title !== "popup" && item.title !== "Banner" && item.isShow === true ? (
                                        <div
                                            className="box-image"
                                            onClick={() => {
                                                if (item.title.indexOf("{") !== 0) {
                                                    setNotifyItem(item);
                                                    setShow(true);
                                                } else {
                                                    navigate(item.content.replace(/<\/?[^>]+(>|$)/g, ""));
                                                }
                                            }}
                                        >
                                            <img alt="" src={item.image} />
                                            {/* Hiện tiêu đề ở dưới bức ảnh, bỏ dấu ngoặc nhọn nếu có */}
                                            <div className="box-image-title">
                                                {item.title.replace("}", "").replace("{", "")}
                                            </div>
                                        </div>
                                    ) : null}
                                </React.Fragment>
                            ))}
                        </AnimatedPage>
                    ) : (
                        <div className="empty-notify">Đang cập nhật dữ liệu...</div>
                    )}
                </div>
            </div>

            {/* 4. MODAL CHI TIẾT */}
            {isShow === true && notifyItem != null ? (
                <div className="custom-modal-overlay" onClick={() => setShow(false)}>
                    <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="custom-modal-header">
                            {notifyItem.title.replace("}", "").replace("{", "")}
                        </div>
                        <div className="custom-modal-body">
                            {notifyItem.content.indexOf("{") !== -1 && notifyItem.content.indexOf("}") !== -1 ? (
                                <img
                                    alt="Chi tiết"
                                    src={notifyItem.content.substring(notifyItem.content.indexOf("{") + 1, notifyItem.content.indexOf("}"))}
                                />
                            ) : (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: notifyItem.content
                                    }}
                                />
                            )}
                        </div>
                        <div className="custom-modal-footer">
                            <button onClick={() => setShow(false)} className="btn-close-modal">
                                Đóng
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}

            <Footer />
        </AnimatedPage>
    );
}

export default Notification;